import React from 'react'

export const EsopEmptyState: React.FC<{ onAddGrant: () => void }> = ({ onAddGrant }) => (
  <div
    className='d-flex flex-column align-items-center justify-content-center text-center py-20'
    style={{ minHeight: 400 }}
  >
    <div className='position-relative mb-8' style={{ width: 96, height: 96 }}>
      <div
        className='d-flex align-items-center justify-content-center rounded-circle border border-primary bg-primary bg-opacity-10'
        style={{
          width: 96,
          height: 96,
          borderWidth: 1,
          borderColor: '#cfe2ff',
          position: 'relative',
        }}
      >
        <div className='d-flex align-items-center gap-1'>
          {/* Trending Up SVG */}
          <img
            src='/media/custom-images/trending-up.svg'
            alt='Trending Up'
            style={{ height: 32, width: 32 }}
          />
          {/* Dollar Sign SVG */}
          <img
            src='/media/custom-images/dollar-sign.svg'
            alt='Dollar Sign'
            style={{ height: 24, width: 24, opacity: 0.8 }}
          />
        </div>
      </div>
      {/* Chart Column SVG badge */}
      <div className='position-absolute' style={{ top: -12, right: -12, width: 32, height: 32 }}>
        <div
          className='d-flex align-items-center justify-content-center rounded-circle border border-2'
          style={{
            background: 'var(--bs-accent, #ffe5ec)',
            width: 32,
            height: 32,
            borderColor: 'var(--bs-body-bg, #fff)',
          }}
        >
          <img
            src='/media/custom-images/chart-column.svg'
            alt='Chart Column'
            style={{ height: 16, width: 16 }}
          />
        </div>
      </div>
    </div>
    <h1 className='fw-bold mb-2' style={{ fontSize: 32 }}>
      Track and unlock the value of your stock options.
    </h1>
    <div className='text-muted mb-6' style={{ fontSize: 18, maxWidth: 500, margin: '0 auto' }}>
      Start by adding your first grant manually, or upload your grant letter or Excel sheet. We'll
      take care of the rest.
    </div>
    <div className='d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 mt-2'>
      <button
        className='btn btn-primary fw-bold px-5 py-3'
        style={{ fontSize: 18 }}
        onClick={onAddGrant}
      >
        <span className='me-2'>+</span> Add a Grant
      </button>
    </div>
  </div>
)
